import { faUsersSlash } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Spinner from '../../../App/Components/Spinner/Spinner'
import { IEstablishment } from '../../../Establishment/interface/IEstablishment'
import { IUser } from '../../DataStore/IUser'
import { getUsersAnonymous } from '../../DataStore/UserDataStore'

import style from './style.scss'

interface IProps {
  establishment: IEstablishment
  onSelect: (user: IUser) => void
}

const Users = ({ establishment, onSelect }: IProps) => {
  const [error, setError] = useState<null | string>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [users, setUsers] = useState<null | IUser[]>(null)

  const { t } = useTranslation()

  useEffect(() => {
    setLoading(true)
    getUsersAnonymous(establishment.id)
      .then((newUsers: IUser[]) => {
        setUsers(newUsers)
        setLoading(false)
      })
      .catch(() => {
        setError('Users could not be retrieved.')
        setLoading(false)
      })
  }, [establishment])

  if (error) {
    return (
      <div className="error-message-wrapper">
        <p className="error-message-text">{t(error)}</p>
        <FontAwesomeIcon icon={faUsersSlash} />
      </div>
    )
  }

  if (loading || null === users) {
    return <Spinner />
  }

  if (0 === users.length) {
    return (
      <div className={'status-message danger'}>
        <p>{t('No users found')}</p>
      </div>
    )
  }

  if (1 === users.length) {
    onSelect(users[0])
  }

  return (
    <>
      <div className={style.userWrapper}>
        {users
          .filter((user: IUser) => user.isActive && !user.isCabin)
          .map((user: IUser) => {
            return (
              <div
                onClick={() => onSelect(user)}
                className={style.user}
                key={'user' + user.id}>
                <div className={style.avatar}>
                  <img src={`${user.avatar}&w=50&h=50&fit=crop`} />
                </div>
                {user.firstName}
              </div>
            )
          })}
      </div>
    </>
  )
}

export default Users
